import * as Features from '../../../../../../shared/Features';

export function canUseNavbarSearch(user: any, isBrokerSuperSearchEnabled: boolean): boolean {
    if (!user || !user.isAuthenticated || !Features.hasFeature(Features.SuperSearchAccess, user)) {
        return false;
    }

    return !user.details.isCustomer || isBrokerSuperSearchEnabled;
}
